export default __webpack_public_path__ + "static/media/BOPPanhandleFirstBankVisionPlanBrandingLogo.e18cb641.png";